import { render, staticRenderFns } from "./ShareholderUpsertProvider.vue?vue&type=template&id=09088e67&scoped=true&"
import script from "./ShareholderUpsertProvider.vue?vue&type=script&lang=ts&"
export * from "./ShareholderUpsertProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09088e67",
  null
  
)

export default component.exports